module.exports = __webpack_public_path__ + "static/media/complete.a3edb05e.svg";